import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { WageHistoryEntry } from './models/wages-with-history-entry';

@Component({
  selector: '[appWagesWithHistory]',
  templateUrl: './wages-with-history.component.html',
  standalone: false,
})
export class WagesWithHistoryComponent {
  @Input() label: string;
  @Input() currentValue: string[];
  @Input() history: WageHistoryEntry[] | null = null;
  @Input() showHistory = true;

  @Output() annexClick = new EventEmitter<number>();

  @ViewChild('panel') panel: MatExpansionPanel;

  get hasHistory(): boolean {
    return this.showHistory && !!this.history && this.history.length > 1;
  }

  togglePanel(): void {
    this.panel?.toggle();
  }

  addWageCount(index: number): string {
    return index === 0 ? '' : ` ${index + 1}`;
  }

  onAnnexClick(event: Event, entry: WageHistoryEntry): void {
    event.stopPropagation();
    if (entry.annexId) {
      this.annexClick.emit(entry.annexId);
    }
  }

  formatWages(entry: WageHistoryEntry): string {
    if (!entry.wages || entry.wages.length === 0) return '-';
    return entry.wages.map((w) => `${w.Value.toFixed(2).replace('.', ',')} ${w.CurrencyName} ${w.WageTypeName}`).join(', ');
  }
}
